function Greece({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_1249)">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
      <path d="M16 11.826H31.4488C31.0476 10.3377 30.4379 8.9351 29.6516 7.6521H16V11.826Z" fill="#338AF3"/>
      <path d="M6.0402 28.5218H25.9598C27.4199 27.3588 28.6722 25.9462 29.6516 24.3479H2.34839C3.32783 25.9462 4.58008 27.3588 6.0402 28.5218Z" fill="#338AF3"/>
      <path d="M5.5652 3.87109C4.30733 4.95428 3.21989 6.22984 2.34839 7.65209H5.5652V3.87109Z" fill="#338AF3"/>
      <path d="M16 16.0001C16 14.3704 16 13.0064 16 11.8262H9.73913V16.0001H5.56519V11.8262H0.551188C0.1925 13.157 0 14.5559 0 16.0001C0 17.4443 0.1925 18.8432 0.551188 20.174H31.4489C31.8075 18.8432 32 17.4443 32 16.0001H16Z" fill="#338AF3"/>
      <path d="M16 0C13.7782 0 11.6623 0.453312 9.73914 1.27175V7.65219H16C16 6.19519 16 4.956 16 3.47825H25.9598C23.2266 1.3015 19.7656 0 16 0Z" fill="#338AF3"/>
    </g>
  </svg>
  `;

  return baseXml;
}

export default Greece;
